import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import AskUpgrade from '../../components/AskUpgrade.js';
import ColumnPicker from "../../components/ColumnPicker";
import OptionColumn from "../../components/general/OptionColumn";
import Template from "./template";
import Portal from 'react-portal';
import FullScreenOverlay from '../../components/FullScreenOverlay.js';
import SplitRows from '../../components/general/SplitRow.js';

class Recommendations extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            askCreate:false,
            askUpgrade:false,
            askDelete:false,
            followUpFor:false,
            recommendations:[],
            currentId:false,
            showDialog:false,
            displayType:'shop',
        }

        this.handleSave = this.handleSave.bind(this);
        this.update = this.update.bind(this);
        this.askDelete = this.askDelete.bind(this);
        this.delete = this.delete.bind(this);
    }

    askDelete(id) {
        this.setState({askDelete:id});
    }

    placeholder() {
        return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
    }

    changeDisplayType = (type) => {
        this.setState({
            displayType:type,
        })
    }

    delete(id) {
        this.setState({askDelete:false,isLoading:true});
        axios.delete('/recommendations/'+id).then(res => {
            this.update();
        });
    }

    handleSave() {
        this.update();
    }

    update() {
        axios.get(`/recommendations`)
            .then(res => {
                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                    'recommendations':res.data
                });
            })
            .catch(res => {
                this.setState({'isError':res.message});
            });
    }

    placeholderRow(rows,cols) {
        let td = [];
        for(let i = 1;i<=cols;i++) {
            td.push(<td key={i}>{this.placeholder()}</td>);
        }

        let row = [];
        for(let i = 1;i<=rows;i++) {
            row.push(<tr key={i}>{td}</tr>);
        }

        return row;
    }

    rows() {
        let data = this.placeholderRow(10,7);
        let num = 0;

        this.state.recommendations.map((recommendation,i) => {
            if(recommendation.type == this.state.displayType || (this.state.displayType == 'shop' && (recommendation.type == '' || !recommendation.type))) {
                data[num] = (
                    <tr key={`template-${recommendation.id}`}>
                        <td>#{recommendation.id}</td>
                        <td style={{textAlign:'left'}}>{recommendation.description}</td>
                        <td style={{textAlign:'left'}}>{recommendation.orders}</td>
                        <td style={{textAlign:'left'}}>{recommendation.clicks}</td>
                        <td style={{textAlign:'left'}}>{recommendation.conversion_rate}%</td>
                        <td style={{textAlign:'left'}}>{recommendation.revenue}</td>
                        <td>
                            <div className="btn-group" role="group">
                                <Tooltip placement="top" overlay={<span>Edit recommendation</span>}>
                                    <Link to={General.Link('/recommendations/'+recommendation.id)} className="btn btn-icon btn-default btn-outline" role="menuitem"><i className="icon wb-pencil" aria-hidden="true"></i></Link>
                                </Tooltip>

                                <Tooltip placement="top" overlay={<span>Delete recommendation</span>}>
                                    <button onClick={(e) => {this.askDelete(recommendation.id)}} type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-trash" aria-hidden="true"></i></button>
                                </Tooltip>
                            </div>
                        </td>
                    </tr>
                );

                num++;

            }
        })

        return data;
    }

    componentWillMount() {
        this.update();
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        if(this.state.recommendations.length == 0) {
            return (
                <div className="page-content">
                    <Helmet title="Recommendations | Crall.io" />
                    <NoResult
                        header="No recommendations found"
                        body="You have not created a recommendation yet. Click the button to get started."
                        link="/recommendations/new"
                        button="Create my first recommendation"
                    />
                </div>
            );
        }

        return (
            <div className="full-height" id="tests">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-users"></i> Recommendations</span>
                    <div className="page-header-actions">

                        <div style={{marginRight:'10px'}} className="btn-group dropdown">
                            <button type="button" className="btn btn-dark dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                <i className="icon fa-plus" style={{marginRight:'10px'}}></i> Create new
                            </button>
                            <div className="dropdown-menu dropdown-menu-bullet dropdown-menu-right" role="menu">
                                <Link to={General.Link('/recommendations/new')} className="dropdown-item" href="javascript:void(0)" role="menuitem">Recommendation</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-content recommendation-list">
                    <Helmet title="Recommendations | Crall.io" />

                    <OptionColumn title="Recommendations" cols={{'left':2,'right':10}} panel={false} description="List of all your recommendations.">

                        <div style={{backgroundColor:'#fff'}}>
                            <div className="nav-tabs-vertical" data-plugin="tabs">
                                <ul className="nav nav-tabs mr-25" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <Tooltip placement="left" overlay={<span>Show shop widgets</span>}>
                                            <a onClick={() => this.changeDisplayType('shop')} className="nav-link active"
                                                data-toggle="tab"
                                                href="#shop"
                                                aria-controls="shop"
                                                role="tab">
                                                <i className="icon wb-shopping-cart m-0" aria-hidden="true"></i>
                                            </a>
                                        </Tooltip>
                                    </li>

                                    <li onClick={() => this.changeDisplayType('email')} className="nav-item" role="presentation">
                                        <Tooltip placement="left" overlay={<span>Show e-mail widgets</span>}>
                                            <a className="nav-link"
                                               data-toggle="tab"
                                               href="#emails"
                                               aria-controls="emails"
                                               role="tab">
                                                <i className="icon wb-envelope m-0" aria-hidden="true"></i>
                                            </a>
                                        </Tooltip>

                                    </li>
                                </ul>
                                <div className="tab-content">
                                    <div className="tab-pane active" id="shop" role="tabpanel">
                                        <table className="table outline text-left">
                                            <tbody>
                                            <tr>
                                                <th>#</th>
                                                <th style={{width:'25%',textAlign:'left'}}>Description</th>
                                                <th>Orders</th>
                                                <th>Clicks</th>
                                                <th>Conversion</th>
                                                <th>Revenue</th>
                                                <th>Actions</th>
                                            </tr>
                                            </tbody>



                                            <tbody>
                                            {this.rows()}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="tab-pane" id="emails" role="tabpanel">
                                        <table className="table outline text-left">
                                            <tbody>
                                            <tr>
                                                <th>#</th>
                                                <th style={{width:'25%',textAlign:'left'}}>Description</th>
                                                <th>Orders</th>
                                                <th>Clicks</th>
                                                <th>Conversion</th>
                                                <th>Revenue</th>
                                                <th>Actions</th>
                                            </tr>
                                            </tbody>



                                            <tbody>
                                            {this.rows()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </OptionColumn>

                </div>
                <Confirm onAccept={(e) => { this.delete(e) }} onClose={() => {this.setState({askDelete:false})}} param={this.state.askDelete} title="Are you sure?" body="Do you want to delete this recommendation?" />
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Recommendations = connect(mapStateToProps,mapDispatchToProps)(Recommendations);
export default Recommendations;



// WEBPACK FOOTER //
// ./containers/recommendations/recommendations.js